import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectService } from '@data/project/project.service';
import { ConfirmationPopupOption, ConfirmationResponse } from '@shared/common-components/confirmation-popup/confirmation-popup.component';
import { changeDateFormatJavaToUi } from '@shared/common-functions/utility';
import { CommonDataService } from '@shared/services/common-data.service';
import { NotificationService } from '@shared/services/notification.service';
import { custom } from 'devextreme/ui/dialog';
import { takeWhile } from 'rxjs/operators';
import { PublishData, AdminService, PublishDataConversion } from '../services/admin.service';
import { AdminService as AS } from '@data/admin/admin.service';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import { exportDataGrid as exportDataGridToPDF } from 'devextreme/pdf_exporter';
import { exportDataGrid, exportDataGrid as exportDataGridToExcel } from 'devextreme/excel_exporter';
import { DxDataGridComponent } from 'devextreme-angular';
import { CommonConstants } from '@mpg-core/constants/common-constants';

@Component({
  selector: 'app-manage-publish-dist',
  templateUrl: './manage-publish-dist.component.html',
  styleUrls: ['./manage-publish-dist.component.less'],
  standalone: false
})
export class ManagePublishDistComponent implements OnInit {

  showPopup: boolean = false;
  showPublishPopup: boolean = false;
  showRevokePopup: boolean = false;
  popupId: string = '';
  popupType: string = '';
  publishListData: PublishData[] = [];
  allPSRGroupsLists: any;
  revokePSRGroupsLists: any;
  selectedPublishGroups: any[] = [];
  selectedRevokeGroups: any[] = [];
  allowedRevokeGroups: any[] = [];
  selectedGroupItems: any;
  disAdmin: boolean = false;
  publishPopoverToolbarItems: any[] = [];
  revokePopoverToolbarItems: any[] = [];
  displayColumns = [
    { caption: 'Weekending Date', dataField: 'weekendingDt', dataType: 'date', format: "MM/dd/yy", width: "10%" },
    { caption: 'Report Name', dataField: 'reportName', dataType: 'string', format: "", width: "20%" },
    { caption: 'Recipient Name', dataField: 'recipientName', dataType: 'string', format: "", width: "12%" },
    { caption: 'Recipient Email', dataField: 'recipientEmail', dataType: 'string', format: "", width: "15%" },
    { caption: 'Published By', dataField: 'publishedBy', dataType: 'string', format: "", width: "10%" },
    { caption: 'Published On', dataField: 'publishedOn', dataType: 'date', format: "MM/dd/yy, HH:mm aa", width: "12%" },
    { caption: 'Last Accessed Date', dataField: 'lastAccessedDate', dataType: 'date', format: "MM/dd/yy, HH:mm aa", width: "12%" },
    { caption: 'Access Revoked', dataField: 'accessRevokedFlag', dataType: 'string', format: "", width: "9%" },
  ];
  title: string = '';
  currentWeekendDate: Date = new Date(
    new Date().setDate(new Date().getDate() - new Date().getDay() + 6)
  );

  isLoading = true;
  loadingWeekendingRollback = true;
  loadingPSRGroupsList = true;

  currentWeekendingDt: string | Date;
  rollbackStatus: boolean;
  openConfirmationPopup: boolean = false;
  confirmationPopupOption: ConfirmationPopupOption;
  isNotifyVisible: boolean = false;
  notifyMessage: any;
  notifyType: string = 'success';
  toastOption: any = {
    message: "Talent Added!",
    type: "success"
  }
  isPublishDisabled: boolean = true;
  PSRGroupsDataSource: any;

  showPublish: boolean = true;
  disPublish: boolean = false;

  exportOption = [
    { value: 1, name: 'PDF', icon: 'pdffile' },
    { value: 4, name: 'Excel', icon: 'xlsfile' }
  ];
  @ViewChild('publish_grid') grid: DxDataGridComponent;
  isSuperAdmin: boolean = false;

  constructor(private commonServices: CommonDataService, private router: Router, private adminService: AdminService, private _admin: AS, private _proj: ProjectService, private _notify: NotificationService) {
    this.openConfirmationPopup = false;


    const userData = this.commonServices.userData.value;
    const getSectionName = userData.filter((item: any) => item.hasOwnProperty("sectionName") && item.sectionName === "Publish & Roll back");
    const getSectionName2 = userData.filter((item: any) => item.hasOwnProperty("sectionName") && item.sectionName === "Admin");
    if (getSectionName2[0].permissionName == "READ ONLY") {
      this.disAdmin = true;
    }
    if (getSectionName[0].permissionName == "READ/WRITE") {
      this.showPublish = true;
    } else if (getSectionName[0].permissionName == "READ ONLY") {
      this.showPublish = true;
      this.disPublish = true;
    } else {
      this.showPublish = false;
    }
    if (this.commonServices.userInfo.value.userRole.roleId === CommonConstants.SUPER_ADMIN_ROLE_ID) {
      this.isSuperAdmin = true;
    }
    this.fetchRequiredData();
  }

  updateToolbarItems() {
    this.publishPopoverToolbarItems = [
      {
        widget: 'dxButton',
        location: 'before',
        options: {
          text: 'Publish',
          type: 'default',
          stylingMode: 'contained',
          onClick: this.confirmPublish.bind(this),
          disabled: !this.selectedPublishGroups.length,
          elementAttr: { class: 'rounded-pill', id: this.popupType }
        },
        toolbar: 'bottom'
      }
    ];
    this.revokePopoverToolbarItems = [
      {
        widget: 'dxButton',
        location: 'before',
        options: {
          text: 'Revoke',
          type: 'default',
          stylingMode: 'contained',
          onClick: this.confirmRevoke.bind(this),
          disabled: !this.selectedRevokeGroups.length,
          elementAttr: { class: 'rounded-pill', id: this.popupType }
        },
        toolbar: 'bottom'
      }
    ];
  }
  onExporting(e:any) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('PSR Distribution Report');

    exportDataGrid({
      component: this.grid.instance,
      worksheet: worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'PSRDistroReport.xlsx');
      });
    });
    e.cancel = true;
  }

  // onExporting(e:any) {

  //   switch (e.itemData.name) {
  //     case "PDF":
  //       const doc = new jsPDF();
  //       exportDataGridToPDF({
  //         jsPDFDocument: doc,
  //         component: this.grid.instance,
  //       }).then(() => {
  //         doc.save("PSRDistroReport.pdf");
  //       });
  //       break;

  //     case "Excel":
  //       const workbook = new Workbook();
  //       const worksheet = workbook.addWorksheet("PSR Distribution Report");
  //       exportDataGridToExcel({
  //         component: this.grid.instance,
  //         worksheet: worksheet,
  //         autoFilterEnabled: true
  //       }).then(() => {
  //         workbook.xlsx.writeBuffer().then((buffer) => {
  //           saveAs(
  //             new Blob([buffer], { type: "application/octet-stream" }),
  //             "PSRDistroReport.xlsx"
  //           );
  //         });
  //       });
  //       break;
  //   }
  // }

  fetchRequiredData() {

    this._admin.getRollbackStatus().pipe(takeWhile(() => this.showPublish)).subscribe((r) => {
      if (r.status == 'SUCCESS' && r.serviceResult) {
        this.rollbackStatus = r.serviceResult.rollbackStatus;
        this.currentWeekendingDt = changeDateFormatJavaToUi(r.serviceResult.currentWeekendingDt, 'mm/dd/yy');
        this.loadingWeekendingRollback = false;
      }
    });


    this.adminService.getAllPSRGroupsList().pipe(takeWhile(() => this.showPublish)).subscribe(
      (res) => {
        if (res.status == 'SUCCESS' && res.serviceResult) {
          this.PSRGroupsDataSource = res.serviceResult ?? [];
          this.selectedPublishGroups = this.PSRGroupsDataSource;
        }
      },
      (e) => {
        console.log(e);
      }
    );

    this.adminService.lastAccessedByReport().subscribe(
      (r) => {
        console.log(r);
        if (r.status == 'SUCCESS') {
          if (r.serviceResult && r.serviceResult.length)
            this.publishListData = PublishDataConversion(r.serviceResult);
          else
            this.publishListData = [];
        }
      },
      (e) => {
        if (e.error.status == "SUCCESS") {
          this.publishListData = [];
        }
        console.log(e);
      }
    );

    this.confirmPublish = this.confirmPublish.bind(this);
    this.confirmRevoke = this.confirmRevoke.bind(this);

  }

  getRollbackStatus() {
    this._admin.getRollbackStatus().subscribe((r) => {
      if (r.status == 'SUCCESS' && r.serviceResult) {
        this.rollbackStatus = r.serviceResult.rollbackStatus;
        this.currentWeekendingDt = changeDateFormatJavaToUi(r.serviceResult.currentWeekendingDt, 'mm/dd/yy');
        this.loadingWeekendingRollback = false;
      }
    });
  }

  confirmRollback() {
    this.confirmationPopupOption = {
      message: 'Are you sure about rolling back the Weekending Date change?',
      rejectButtonText: 'NO',
      normalButtonText: '',
      confirmButtonText: 'YES',
      showCloseButtn: false,
      visible: true,
      option: 'rollbackWeekend',
    };
    this.openConfirmationPopup = true;
  }

  confirmRollforward() {
    this.confirmationPopupOption = {
      message: 'Are you sure about rolling forward the Weekending Date?',
      rejectButtonText: 'NO',
      normalButtonText: '',
      confirmButtonText: 'YES',
      showCloseButtn: false,
      visible: true,
      option: 'rollforwardWeekend',
    };
    this.openConfirmationPopup = true;
  }

  confirmationChanges(res: ConfirmationResponse) {
    this.openConfirmationPopup = false;
    if (res.option == 'rollbackWeekend' && res.confirmation) {
      this.rollback();
    } else if (res.option == 'rollforwardWeekend' && res.confirmation) {
      this.rollForward();
    } else if (res.option == 'publish' && res.confirmation) {
      this.showPublishPopup = false;
      this.publishPSRGroups();
    }
    else if (res.option == 'revoke' && res.confirmation) {
      this.showRevokePopup = false;
      this.revokePSRGroups();
    }
    // else if (res.option == 'createTitle' && res.confirmation) {
    //   this.createProject();
    // }
  }


  rollback() {
    this.loadingWeekendingRollback = true;
    this._admin.rollBack().subscribe((r) => {
      console.log(r);
      if (r.status == 'SUCCESS') {
        this.getRollbackStatus();
      }
    });
  }

  rollForward() {
    this.loadingWeekendingRollback = true;
    this._admin.rollForward().subscribe((r) => {
      console.log(r);
      if (r.status == 'SUCCESS') {
        this.getRollbackStatus();
      }
    });
  }

  ngOnInit(): void {
    this.updateToolbarItems()
  }

  onResetNotify() {
    this.notifyType = 'success';
    this.notifyMessage = '';
    this.isNotifyVisible = false;
  }


  ckeckPublish() {
    this.showPublishPopup = false;
    this.selectedPublishGroups = this.PSRGroupsDataSource;
    
    this.publishPopoverToolbarItems = [
      {
        widget: 'dxButton',
        location: 'before',
        options: {
          text: 'Publish',
          type: 'default',
          stylingMode: 'contained',
          disabled: !this.selectedPublishGroups.length,
          onClick: this.confirmPublish.bind(this),
          elementAttr: { class: 'rounded-pill', id: this.popupType }
        },
        toolbar: 'bottom'
      }
    ];
    this.adminService.checkPublishStatus().subscribe(
      r => {
        if (r.status == 'SUCCESS') {
          if (r.serviceResult && r.serviceResult.toString().toLowerCase().trim() == "inprogress") {
            this.confirmationPopupOption = {
              message: 'Publish process already in progress',
              rejectButtonText: '',
              normalButtonText: '',
              confirmButtonText: 'OK',
              showCloseButtn: false,
              visible: true,
              option: '',
            };
            this.openConfirmationPopup = true;
          }
          else {
            this.showPublishPopup = true;
          }

        }

      }
    );
    
  }

  confirmPublish() {
    this.confirmationPopupOption = {
      message: 'Please confirm, do you want to proceed with PSR Publish process',
      rejectButtonText: 'No',
      normalButtonText: '',
      confirmButtonText: 'Yes',
      showCloseButtn: false,
      visible: true,
      option: 'publish',
    };
    this.openConfirmationPopup = true;
  }

  checkRevoke() {
    this.selectedRevokeGroups = [];
    this.allowedRevokeGroups = [];
    
    this.revokePopoverToolbarItems = [
      {
        widget: 'dxButton',
        location: 'before',
        options: {
          text: 'Revoke',
          type: 'default',
          stylingMode: 'contained',
          onClick: this.confirmRevoke.bind(this),
          disabled: !this.selectedRevokeGroups.length,
          elementAttr: { class: 'rounded-pill', id: this.popupType }
        },
        toolbar: 'bottom'
      }
    ];
    this.adminService.getAllPSRGroupsList().subscribe(
      (res) => {
        if (res.status == 'SUCCESS' && res.serviceResult) {
          this.PSRGroupsDataSource = res.serviceResult ?? [];
          this.selectedPublishGroups = this.PSRGroupsDataSource;
          this.showRevokePopup = true
        }
      },
      (e) => {
        console.log(e);
      }
    );
  }

  confirmRevoke() {
    this.allowedRevokeGroups = [];
    let strAr = [];
    for (let s of this.selectedRevokeGroups) {
      if (s.publishedFlag == true) {
        this.allowedRevokeGroups.push(s);
        strAr.push(s.psrGroupName);
      }
    }

    let msg = '';

    if (this.allowedRevokeGroups.length) {
      if (this.allowedRevokeGroups.length < this.selectedRevokeGroups.length)
        msg = 'Only the following reports are qualified to be revoked : ' + strAr.toString() + ". Press YES to proceed.";
      else
        msg = 'Please confirm, do you want to proceed with PSR Revoke process';
      this.confirmationPopupOption = {
        message: msg,
        rejectButtonText: 'No',
        normalButtonText: '',
        confirmButtonText: 'Yes',
        showCloseButtn: false,
        visible: true,
        option: 'revoke',
      };
      this.openConfirmationPopup = true;
    }
    else {
      msg = 'Selected reports are not yet published';
      this.confirmationPopupOption = {
        message: msg,
        rejectButtonText: 'OK',
        normalButtonText: '',
        confirmButtonText: '',
        showCloseButtn: false,
        visible: true,
        option: 'revoke',
      };
      this.openConfirmationPopup = true;
    }
  }

  publishPSRGroups() {
    this.adminService.publishPSRGroups(this.selectedPublishGroups).subscribe((r) => {
      if (r.status == 'SUCCESS' && r.serviceResult) {
        this.notifyMessage = r.serviceResult;
        this.notifyType = 'success';
        this.isNotifyVisible = true;
        this.isLoading = false;
      }
    });
    let msg = "<div>The PSR publish and distribute process is now in progress.</div>Users will be notified accordingly once the process completes.";
    let customAlertDialog = custom({
      showTitle: false,
      messageHtml: msg,
      buttons: [
        { text: "Ok", onClick: () => true }
      ]
    });
    customAlertDialog.show()
      .then((dialogResult: any) => {
        // console.log(dialogResult);
        this.isPublishDisabled = true;
        this.isLoading = false;
      });
  }

  revokePSRGroups() {
    // console.log('revoke', this.selectedGroupItems);
    // this.isLoading = true;
    if (this.allowedRevokeGroups.length) {
      this.adminService.revokePSRGroups(this.allowedRevokeGroups).subscribe((r) => {
        if (r.status == 'SUCCESS' && r.serviceResult) {
          this.notifyMessage = r.serviceResult;
          this.notifyType = 'success';
          this.isNotifyVisible = true;
          this.isLoading = false;
        }
      });
    }
  }

  onSelectionChange(event: any, option: string) {
    // console.log('selection', event);
    if (option == 'publish') {
      this.selectedPublishGroups = event.component.option('selectedItems');
    }
    else if (option == 'revoke') {
      this.selectedRevokeGroups = event.component.option('selectedItems');
    }
    this.updateToolbarItems()
    // this.selectedGroupItems = event.component.option('selectedItems');
    // if(!this.selectedGroupItems.length)
    //   this.isPublishDisabled=true;
    // else
    //   this.isPublishDisabled=false;
  }

  getDisabledDates(args: any): boolean {
    const dayOfWeek = args.date.getDay();
    const isNotWeekend = dayOfWeek != 6;
    return args.view === "month" && (isNotWeekend);
  }

  ngOnDestroy() {
    this._notify.removeErrorOnTabChange('manage-publish-dist');
  }

}

